import React, { FC } from 'react';
import styles from '../EnvelopeItem.module.scss';

import { useAllowedActions } from '@hooks/envelopes/useAllowedActions';

import { useTranslation } from 'react-i18next';

import {
  ComboButton,
  ILibDropdownItem,
  ILibHorizontalPosition,
} from '@infologistics/frontend-libraries';

import {
  checkAllowedActions,
  getAllowedAction,
  getOptionsAllowedAction,
} from '@views/envelopes/utils';
import { actionButtonSettings } from '@views/envelopes/consts';

import { IEnvelopeActionsProps as IProps } from '@views/envelopes/types';
import {
  catchThunkError,
  getEnvelopeQualifiedSignature,
} from '@app/utils/utils';
import { EnvelopeAllovedActions, EnvelopeAllowedActionsButton } from '@app/const/consts';
import { useAppDispatch, useAppSelector } from '@app/hooks/redux';
import { getEnvelope } from '@app/store/modules/envelopes';

const EnvelopeActions: FC<IProps> = ({
  allowedActions,
  oguid,
  subject,
  boxOguid,
  onOpenDeclineModal
}) => {
  const { t } = useTranslation(['envelopes']);
  const { handleClickAllowedActions } = useAllowedActions();

  const checkedAllowedActions = checkAllowedActions(allowedActions);
  const allowedActionValue = getAllowedAction(checkedAllowedActions);
  const { title, theme } = actionButtonSettings[allowedActionValue];

  const currentUserBoxOguid =
    useAppSelector((state) => state.boxes.boxes).find(
      (val) => val.oguid === boxOguid
    )?.oguid ?? '';

  const { instance } = useAppSelector((state) => state.utils);
  const dispatch = useAppDispatch();

  const dropdownItems = getOptionsAllowedAction(
    false,
    checkedAllowedActions
  ).map((item) => {
    const { translation = '' } = item;

    return {
      ...item,
      translation: t(translation),
    };
  });

  const handleSelectDropDown = (option: ILibDropdownItem): void => {
    if (
      option.data === EnvelopeAllovedActions.DECLINE_APPROVE ||
      option.data === EnvelopeAllovedActions.DECLINE_SIGN
    ) {
      onOpenDeclineModal();
      dispatch(getEnvelope({ oguid, boxOguid }))
        .unwrap()
        .then((resp) => {
          if (resp) {
            handleClickAllowedActions({
              option,
              oguid,
              subject,
              boxOguid,
            });
          }
        })
        .catch((err) => {
          catchThunkError(err);
          onOpenDeclineModal(true);
        });
    } else {
      handleClickAllowedActions({ option, oguid, subject, boxOguid });
    }
  };

  const handleClickButton = (): void => {
    const option = { name: allowedActionValue };

    if (allowedActionValue === EnvelopeAllowedActionsButton.SIGN && boxOguid) {
      dispatch(getEnvelope({ oguid, boxOguid }))
        .unwrap()
        .then((resp) => {
          if (resp) {
            handleClickAllowedActions({
              option,
              oguid,
              isQualifiedSignature: getEnvelopeQualifiedSignature(
                resp,
                currentUserBoxOguid,
                instance
              ),
              boxOguid,
            });
          }
        })
        .catch(catchThunkError);
    } else {
      handleClickAllowedActions({ option, oguid, boxOguid });
    }
  };

  return (
    <td>
      <ComboButton
        selectedTitle={t(title)}
        buttonTheme={theme}
        containerClasses={styles.actionButton}
        dropdownItems={dropdownItems}
        itemClasses='py-1'
        size='small'
        horizontalPosition={ILibHorizontalPosition.RIGHT}
        onSelect={handleSelectDropDown}
        allowDropdownFlip
        correctViewport={{ bottom: 48 }}
        onClick={handleClickButton}
      />
    </td>
  );
};

export default EnvelopeActions;
